// Android のハードウェア戻るボタン（Capacitor App の backButton）を一時的に無効化するためのガード。
// 「保存するまで閉じられない」モーダル表示中など、戻る操作でモーダルを回避されると困る場面で使用する。
// 参照カウント方式のため、複数箇所から同時にブロックしても正しく解除される。

let blockerCount = 0;

/**
 * 戻るボタンをブロックする。戻り値の関数を呼ぶとブロックを解除する。
 * useEffect のクリーンアップで解除するのを想定。
 */
export const blockBackButton = (): (() => void) => {
  blockerCount += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    blockerCount = Math.max(0, blockerCount - 1);
  };
};

/** 現在戻るボタンがブロックされているか。 */
export const isBackButtonBlocked = (): boolean => blockerCount > 0;
